import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, mergeMap, catchError } from 'rxjs/operators';
import { DashboardService } from '../../services/dashboard.service';
import * as InventoryAction from './inventory.action';

@Injectable()
export class InventoryEffects {

  loadInventory$ = createEffect(() =>
    this.actions$.pipe(
      ofType('inventory'),
      mergeMap(() => this.dashboardService.getInventory()
        .pipe(
            map(inventory => new InventoryAction.GetInventory(inventory)),
          catchError(() => of({ type: 'inventory load error' }))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private dashboardService: DashboardService
  ) {}
}